import React, { useMemo, useState } from "react";
import { estimateMonitoringRequest } from "../../utils/monitoringUtils";

export default function MonitorRunDialog({ paths, isSubmitting, error, onClose, onSubmit }) {
  const eligiblePaths = paths.filter((path) => path.points?.length >= 2 && path.points.length <= 25);
  const [duration, setDuration] = useState(60);
  const [interval, setInterval] = useState(120);
  const [selectedIds, setSelectedIds] = useState(() => new Set(eligiblePaths.slice(0, 20).map((path) => path.id)));
  const selectedPaths = paths.filter((path) => selectedIds.has(path.id));
  const estimate = useMemo(() => estimateMonitoringRequest(duration, interval, selectedPaths), [duration, interval, selectedPaths]);
  const isValid = duration >= 1 && duration <= 300 && interval >= 60 && selectedPaths.length >= 1 && selectedPaths.length <= 20;

  const togglePath = (pathId) => setSelectedIds((current) => {
    const next = new Set(current);
    if (next.has(pathId)) next.delete(pathId);
    else if (next.size < 20) next.add(pathId);
    return next;
  });

  return (
    <div className="dc-modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="dc-modal" role="dialog" aria-modal="true" aria-labelledby="monitor-dialog-title">
        <div className="dc-modal-header">
          <div><span>Traffic collection</span><h2 id="monitor-dialog-title">Monitor paths</h2></div>
          <button type="button" aria-label="Close" onClick={onClose}>×</button>
        </div>
        <p className="dc-modal-intro">Choose how long to collect Google traffic data and which paths to include.</p>
        <div className="dc-monitor-fields">
          <label>Duration <span>minutes · max 5 hours</span><input type="number" min="1" max="300" value={duration} onChange={(event) => setDuration(Number(event.target.value))} /></label>
          <label>Sampling interval <span>seconds</span><input type="number" min="60" value={interval} onChange={(event) => setInterval(Number(event.target.value))} /></label>
        </div>
        <div className="dc-path-picker-heading"><strong>Select paths</strong><span>{selectedPaths.length}/20 selected</span></div>
        <div className="dc-path-picker">
          {paths.map((path) => {
            const pointCount = path.points?.length || 0;
            const eligible = pointCount >= 2 && pointCount <= 25;
            return (
              <label key={path.id} className={!eligible ? "disabled" : ""}>
                <input type="checkbox" checked={selectedIds.has(path.id)} disabled={!eligible} onChange={() => togglePath(path.id)} />
                <span><strong>{path.name || "Untitled path"}</strong><small>{pointCount} points{!eligible ? " · requires 2–25" : ""}</small></span>
              </label>
            );
          })}
        </div>
        <div className="dc-estimate">
          <span><strong>{estimate.samplesPerPath}</strong> estimated samples per path</span>
          <span><strong>{estimate.googleRequests}</strong> estimated Google requests</span>
        </div>
        {error && <div className="dc-error">{error}</div>}
        <div className="dc-modal-actions">
          <button type="button" onClick={onClose}>Cancel</button>
          <button className="dc-primary" type="button" disabled={!isValid || isSubmitting} onClick={() => onSubmit({ durationMinutes: duration, pollingIntervalSeconds: interval, paths: selectedPaths })}>
            {isSubmitting ? "Starting…" : "Start monitoring"}
          </button>
        </div>
      </section>
    </div>
  );
}
